import { useState, useEffect } from "react";
import { lucidWorksService } from "./lucidworks.js";
const useLucidWorks = (entry, q, slug, locale) => {
  const [itemIds, setItemIds] = useState([]);
  const { third_party_curation } = entry;
  const { lucidworks_placement_name } = third_party_curation || {};
  const fetchLW = () => {
    if (!lucidworks_placement_name) {
      return;
    }
    lucidWorksService(q, slug, locale).then((res) => {
      var _a, _b;
      if (!res) {
        setItemIds([]);
        return;
      }
      setItemIds(
        ((_b = (_a = res.response) == null ? void 0 : _a.docs) == null ? void 0 : _b.map(({ group_id = "" }) => group_id)) || []
      );
    });
  };
  useEffect(() => {
    fetchLW();
  }, [third_party_curation]);
  return { itemIds };
};
export {
  useLucidWorks
};
